export default "assets/images/3-stars-40e7dac7.svg";